import { getUsers, handleError, getBusinessTypes, } from '@/modules/userSettings/_api';

const limit = 15;

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    all: [],
    users: [],
    current: null,
    keyword: '',
    filtered: [],
    pageCount: 0,
    totalCount: 0,
    showConfirmModal: false,
    submitLoading: false,
    businessTypes: [],
    activeBusinessType: [],
    roles: [],
    permissions: [],
    rolesPositions: [],
    rolesWorkGroups: [],
    states: [],
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.all,
    current: (state,) => state.current,
    users: (state,) => state.keyword ? state.filtered : state.users,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
    filtered: (state,) => state.filtered,
    keyword: (state,) => state.keyword,
    showConfirmModal: (state,) => state.showConfirmModal,
    submitLoading: (state,) => state.submitLoading,
    businessTypes: (state,) => state.businessTypes,
    activeBusinessType: (state,) => state.activeBusinessType,
    roles: (state,) => state.roles,
    permissions: (state,) => state.permissions,
    rolesPositions: (state,) => state.rolesPositions,
    rolesWorkGroups: (state,) => state.rolesWorkGroups,
    states: (state,) => state.states,
  },
  // -----------------------------------------------------------------
  mutations: {
    setAll: (state, users,) => (state.all = users),
    setUsers: (state, users,) => (state.users = users),
    setCurrent: (state, user,) => (state.current = user),
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
    setFiltered: (state, filtered,) => (state.filtered = filtered),
    setKeyword: (state, keyword,) => (state.keyword = keyword),
    toggleModal: (state, status,) => (state.showConfirmModal = status),
    setSubmitLoading: (state, status,) => (state.submitLoading = status),
    setBusinessTypes: (state, businessTypes,) => (state.businessTypes = businessTypes),
    setActiveBusinessType: (state, businessType,) => 
      (state.activeBusinessType = businessType),
    setRoles: (state, roles,) => (state.roles = roles),
    setPermissions: (state, permissions,) => (state.permissions = permissions),
    setRolesPositions: (state, positions,) => (state.rolesPositions = positions),
    setRolesWorkGroups: (state, workgroups,) => (state.rolesWorkGroups = workgroups),
    setStates: (state, states,) => (state.states = states),
  },
  // -----------------------------------------------------------------
  actions: {
    get: ({ commit, state, },) => {
      commit('userSettings/setUsers', [], { root: true, },);
      return getUsers().then(
        (response,) => {
          const items = response.data;
          const users = items.data.map((user,) => (
            {
              id: user._id,
              name: user.name, 
              email: user.email, 
              roles: user.roles?.map((role,) => role.name,).join(',',), 
              status: user.deletedAt ? 'Excluído' : user.active ? 'Ativo' : 'Inativo',
              businessType: user.businessType,
              workGroup: user.workGroup,
            }
          ),);
          const usersBySelectedBusinessType = filterUsers(sortUsers(users,), '', state,);

          commit('userSettings/setAll', sortUsers(users,), { root: true, },);
          commit('userSettings/setUsers', usersBySelectedBusinessType, { root: true, },);
          commit('userSettings/setPageCount', Math.ceil(usersBySelectedBusinessType.length / limit,), {
            root: true,
          },);
          commit('userSettings/setTotalCount', usersBySelectedBusinessType.length, { root: true, },);
        },
        (error,) => {
          return handleError(error,);
        },
      );
    },
    filter: ({ commit, state, }, payload,) => {
      const { keyword, } = payload || state;
      const { users, } = state;
      const filtered = filterUsers(users, keyword, state,);

      const pageCount = Math.ceil(filtered.length / limit,);
      const totalCount = filtered.length;

      commit('setFiltered', filtered,);
      commit('setPageCount', pageCount,);
      commit('setTotalCount', totalCount,);
    },
    setCurrent ({ commit, }, user,) {
      commit('setCurrent', user,);
    },
    setKeyword ({ commit, }, keyword,) {
      commit('setKeyword', keyword,);
    },
    toggleModal ({ commit, }, status,) {
      commit('toggleModal', status,);
    },
    setSubmitLoading ({ commit, }, status,) {
      commit('setSubmitLoading', status,);
    },
    updateUser ({ commit, state, }, payload,) {
      const {id, body,} = payload;
      const { users, } = state;
      const updatedUsers = users.map((user,) => {
        if (user.id === id) {
          return {...user, ...body, };
        }   
        return user;
      },);
      commit('setUsers', updatedUsers,);
    },
    getBusinessTypes: ({ commit, },) => {
      commit('userSettings/setBusinessTypes', [], { root: true, },);
      return getBusinessTypes().then(  ({ data: businessTypes, },) => {
        businessTypes.forEach((businessType,) => {
          switch(businessType.key) {
          case 'franqueadora':
            businessType.label = 'Colaboradores';
            break;
          case 'franquia':
            businessType.label = 'Franqueados';
            break;
          }
        },);
        commit('userSettings/setBusinessTypes', businessTypes, { root: true, },);
        commit('userSettings/setActiveBusinessType', businessTypes[0], {root: true, },);
      },);
    },
    setBusinessType: ({commit, state, }, businessType,) => {
      commit('setKeyword', state.keyword,);
      commit('userSettings/setActiveBusinessType', businessType, {root: true, },);

      const usersBySelectedBusinessType = filterUsers(state.all, state.keyword, state,);

      commit('userSettings/setUsers', usersBySelectedBusinessType, { root: true, },);
      commit('userSettings/setFiltered', usersBySelectedBusinessType, {root: true, },);
      commit('userSettings/setPageCount', Math.ceil(usersBySelectedBusinessType.length / limit,), {
        root: true,
      },);
      commit('userSettings/setTotalCount', usersBySelectedBusinessType.length, { root: true, },);
    },
    setRoles: ({ commit, }, roles,) => {
      commit('setRoles', roles,);
    },
    setPermissions: ({ commit, }, permissions,) => {
      commit('setPermissions', permissions,);
    },
    setRolesPositions: ({ commit, }, positions,) => {
      commit('setRolesPositions', positions,);
    },
    setRolesWorkGroups: ({ commit, }, workgroups,) => {
      commit('setRolesWorkGroups', workgroups,);
    },
    setStates: ({ commit, }, states,) => {
      commit('setStates', states,);
    },
  },
  // -----------------------------------------------------------------
};

const sortUsers = (users,) => {
  return users.sort((user1, user2,) => (user1.name < user2.name ? -1 : 1),);
};

const normalize = (text,) => {
  return text.toLowerCase().
    normalize('NFD',).
    replace(/[\u0300-\u036f]/g, '',);
};

const filterUsers = (users, keyword, state,) => {
  return users.filter((user,) => {
    return (
      (normalize(user.name,).includes(normalize(keyword,),) ||
      normalize(user.email,).includes(normalize(keyword,),)) &&
      user.businessType &&
      user.businessType._id === state.activeBusinessType._id
    );
  },);
};
